import PropTypes from "prop-types";
import React, { Component } from "react";
import { Container, Icon, Menu, Responsive, Segment, Sidebar } from "semantic-ui-react";
import LogoutButton from "../../../LogoutButton";
import LoginButton from "../../../LoginButton";
import HomepageHeading from "../Heading";
import ProfileLink from "../ProfileLink";
import ClockLink from "../../../../scenes/Clock/Links";
import ToolLink from "../../../../scenes/Tools/Links";
import InventoryLink from "../../../../scenes/Inventory/Links";
import AdminLink from "../AdminLink";
import LanguageToggle from "../LanguageToggle";


class MobileContainer extends Component {
    state = {}

    handlePusherClick = () => {
        const { sidebarOpened } = this.state;

        if (sidebarOpened) this.setState({sidebarOpened: false})
    }

    handleToggle = () => this.setState({ sidebarOpened: !this.state.sidebarOpened });

    render() {
        const { children, heading } = this.props;
        const { sidebarOpened } = this.state;


        return (
            <Responsive {...Responsive.onlyMobile}>
                <Sidebar.Pushable>
                    <Sidebar as={Menu} animation='push' width='thin' inverted vertical visible={sidebarOpened}>
                        <Menu.Item as='a' active>Home</Menu.Item>
                        <AdminLink mobile/>
                        <ClockLink mobile/>
                        <ToolLink mobile/>
                        <InventoryLink mobile/>
                        <ProfileLink mobile/>
                        <LanguageToggle mobile/>
                    </Sidebar>

                    <Sidebar.Pusher dimmed={sidebarOpened} onClick={this.handlePusherClick}
                                    style={{minHeight: '100vh'}}>
                        <Segment inverted textAlign='center' style={{
                            minHeight: heading ? 350 : 0,
                            padding: '1em 0em',
                            background: !heading ? 'rgba(0, 0, 0, 0.9)' : 'linear-gradient( rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5) ),url("https://www.tn-spezialitaeten.ch/wp-content/uploads/2017/10/hintergrund_bright.png")',
                            backgroundSize: 'cover'
                        }} vertical>
                            <Container style={{backgroundColor: 'rgba(0,0,0,0.0)'}}>
                                <Menu inverted pointing secondary size='large' style={{border: 'none'}}>
                                    <Menu.Item onClick={this.handleToggle}>
                                        <Icon name='sidebar'/>
                                    </Menu.Item>
                                    <LoginButton fixed={false}/>
                                    <LogoutButton fixed={false}/>
                                </Menu>
                            </Container>
                            {heading ? <HomepageHeading mobile/> : ''}

                        </Segment>
                        {children}
                    </Sidebar.Pusher>
                </Sidebar.Pushable>
            </Responsive>
        )
    }
}

MobileContainer.propTypes = {
    children: PropTypes.node,
};

export default MobileContainer;



// WEBPACK FOOTER //
// ./src/components/Homepage/components/MobileContainer/index.js